import { Checkbox } from "antd";
import { useState } from "react";

import { PopClose } from "./FilterBar";

/** URL の描画を待たずにチェックを反映し、戻る・条件解除では URL の値に合わせる。 */
export function MultiSelectControl({
  options,
  selected,
  onChange,
  onClose,
}: {
  options: { value: string; label: string }[];
  selected: string[];
  onChange: (values: string[]) => void;
  onClose: () => void;
}) {
  const source = JSON.stringify(selected);
  const [lastSource, setLastSource] = useState(source);
  const [values, setValues] = useState(selected);
  // 呼び出し元は描画ごとに配列を作るため、参照ではなく値の変更で同期する。
  if (source !== lastSource) {
    setLastSource(source);
    setValues(selected);
  }

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {options.map((option) => (
          <Checkbox
            key={option.value}
            checked={values.includes(option.value)}
            onChange={(e) => {
              const next = e.target.checked
                ? options.filter((o) => values.includes(o.value) || o.value === option.value).map((o) => o.value)
                : values.filter((v) => v !== option.value);
              setValues(next);
              onChange(next);
            }}
          >
            {option.label}
          </Checkbox>
        ))}
      </div>
      <PopClose onClick={onClose} />
    </>
  );
}
